import label from "@/lang/StaticLabels.js";

// PHAMYAR Navbar  - همیار -----------------------------------------------
let navItems = [
  {
    title: label.modules.phamyar,
    icon: "mdi-map-marker-radius",
    to: false,
  },
  {
    to: "PHAMYARDashboard",
    label: label.menu.dashboard,
    icon: "pi pi-home",
    active: false,
    subItems: false,
    divider: true,
  },
  {
    to: null,
    label: label.menu.baseInformation,
    icon: "pi pi-database",
    active: false,
    subItems: [
      {
        to: "PHAMYARGoalList",
        label: label.menu.goals,
        metaLabel: label.page.goals,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      // منوی کاربران هدف و زمان‌بندی هدف فعلاً غیرفعال است.
      // {
      //   to: "PHAMYARGoalUser",
      //   label: label.menu.goalUser,
      //   metaLabel: label.page.goalUser,
      //   icon: "mdi-subdirectory-arrow-left",
      //   active: false,
      //   subItems: [],
      // },
      // {
      //   to: "PHAMYARGoalSchedule",
      //   label: label.menu.goalSchedule,
      //   metaLabel: label.page.goalSchedule,
      //   icon: "mdi-subdirectory-arrow-left",
      //   active: false,
      //   subItems: [],
      // },
      {
        to: "PHAMYARTaskCategory",
        label: label.menu.taskCategory,
        metaLabel: label.page.taskCategory,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PHAMYARNoteCategory",
        label: label.menu.noteCategory,
        metaLabel: label.page.noteCategory,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PHAMYARNoteSubject",
        label: label.menu.noteSubject,
        metaLabel: label.page.noteSubject,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PHAMYARCallCategory",
        label: label.menu.callCategory,
        metaLabel: label.page.callCategory,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PHAMYARCallSubject",
        label: label.menu.callSubject,
        metaLabel: label.page.callSubject,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PHAMYARServiceSupportSubject",
        label: label.menu.serviceSupportSubject,
        metaLabel: label.page.serviceSupportSubject,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      // منوی نوع درخواست فعلاً غیرفعال است.
      // {
      //   to: "PHAMYARRequestType",
      //   label: label.menu.hamyarRequestType,
      //   metaLabel: label.page.hamyarRequestType,
      //   icon: "mdi-subdirectory-arrow-left",
      //   active: false,
      //   subItems: [],
      // },
      {
        to: "PHAMYARProjectType",
        label: label.menu.hamyarProjectType,
        metaLabel: label.page.hamyarProjectType,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PHAMYARWorkDescription",
        label: label.menu.workDescription,
        metaLabel: label.page.workDescription,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PHAMYARSetting",
        label: label.menu.settings,
        metaLabel: label.page.settings,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
  {
    to: null,
    label: label.menu.operation,
    icon: "mdi-wrench-outline",
    active: false,
    subItems: [
      {
        to: "PHAMYARTaskList",
        label: label.menu.tasks,
        metaLabel: label.page.tasks,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PHAMYARProjectList",
        label: label.menu.projects,
        metaLabel: label.page.projects,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PHAMYARMeetingList",
        label: label.menu.meeting,
        metaLabel: label.page.meeting,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PHAMYARNoteList",
        label: label.menu.notes,
        metaLabel: label.page.notes,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      // منوی درخواست‌ها فعلاً غیرفعال است.
      // {
      //   to: "PHAMYARRequestList",
      //   label: label.menu.requests,
      //   metaLabel: label.page.requests,
      //   icon: "mdi-subdirectory-arrow-left",
      //   active: false,
      //   subItems: [],
      // },
      {
        to: "PHAMYARCallList",
        label: label.menu.calls,
        metaLabel: label.page.calls,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PHAMYARMessageList",
        label: label.menu.messages,
        metaLabel: label.page.messages,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PHAMYARServiceSupportList",
        label: label.menu.serviceSupports,
        metaLabel: label.page.serviceSupports,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
      {
        to: "PHAMYARWorkCalendar",
        label: label.menu.workCalendar,
        metaLabel: label.page.workCalendar,
        icon: "mdi-subdirectory-arrow-left",
        active: false,
        subItems: [],
      },
    ],
  },
];

export default navItems;
